import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import data from "@/data/projects/projects.json";
import PageSEO from "@/components/common/PageSEO";
import Loading from "@/components/common/Loading";
import ProjectsHorizontal from "@/components/portfoliu/projects-horizontal/ProjectsHorizontal";
import Filters from "@/components/portfoliu/filters/Filters";
import Intro from "@/components/service/components/intro/Intro";
import { ProjectData } from "./Project";

type ProjectPreview = Pick<
  ProjectData,
  "id" | "title" | "imgUrl" | "details" | "list" | "date" | "tags" | "type"
>;

const Portfoliu = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [projects, setProjects] = useState<ProjectPreview[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    setProjects(data);
    setLoading(false);
  }, []);

  // Portfolio intro data - Pixado style
  const portfolioIntroData = {
    tag: "Portfoliu",
    title: "CHAMPIONS LEAGUE",
    text: "Aici găsești doar proiecte Champions League. Nu facem siteuri de liga a 3-a.",
    description: "Custom code, performanță maximă, zero compromisuri. Fiecare proiect construit să domine piața."
  };

  if (loading) return <Loading />;

  return (
    <>
      <PageSEO section="portfolio" keyName="main" />
      <Intro data={portfolioIntroData} />
      <Container style={{ marginTop: "-40px", textAlign: "center" }}>
        <div style={{ 
          display: "inline-block", 
          fontSize: "0.7em",
          transform: "scale(0.85)"
        }}>
          <Filters projects={data} setProjects={setProjects} />
        </div>
      </Container>
      <Container style={{ height: "100%" }}>
        <ProjectsHorizontal projects={projects} />
      </Container>
    </>
  );
};

export default Portfoliu;